(function(){
  document.addEventListener('click', function(e) {
    document.querySelectorAll('.custom-select').forEach(function(wrapper) {
      const trigger = wrapper.querySelector('.custom-select__trigger');
      const options = wrapper.querySelector('.custom-select__options');
      if (!trigger || !options) return;

      // Toggle aç/kapa
      if (trigger.contains(e.target)) {
        const expanded = trigger.getAttribute('aria-expanded') === 'true';
        trigger.setAttribute('aria-expanded', (!expanded).toString());
        options.classList.toggle('open', !expanded);
      } else {
        if (!wrapper.contains(e.target)) {
          options.classList.remove('open');
          trigger.setAttribute('aria-expanded', 'false');
        }
      }

      // Seçim
      const optionButton = e.target.closest('.custom-select__option');
      if (optionButton && optionButton.dataset.url) {
        window.location.href = optionButton.dataset.url;
      }
    });
  });

  // Escape ile kapat
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.custom-select__options').forEach(function(opt) {
        opt.classList.remove('open');
      });
      document.querySelectorAll('.custom-select__trigger').forEach(function(tr) {
        tr.setAttribute('aria-expanded', 'false');
      });
    }
  });
})();
